import { __decorate, __metadata } from 'tslib';
import { Input, Component, EventEmitter, Output, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';

function OrgChartComponent_org_chart_entity_0_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "org-chart-entity", 3);
    ɵngcc0.ɵɵlistener("toggleChild", function OrgChartComponent_org_chart_entity_0_Template_org_chart_entity_toggleChild_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r2 = ɵngcc0.ɵɵnextContext(); return ctx_r2.toggleShowChild($event); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("data", ctx_r0.data)("hasParent", ctx_r0.hasParent)("hideChild", ctx_r0.hideChild);
} }
function OrgChartComponent_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 4);
    ɵngcc0.ɵɵelementStart(2, "div", 5);
    ɵngcc0.ɵɵelement(3, "div", 6);
    ɵngcc0.ɵɵelement(4, "div", 7);
    ɵngcc0.ɵɵelement(5, "div", 6);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(6, "angular-org-chart", 8);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const data_r4 = ctx.$implicit;
    const isFirst_r5 = ctx.first;
    const isLast_r6 = ctx.last;
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵstyleProp("border-color", isFirst_r5 ? "transparent" : "");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵstyleProp("border-color", isLast_r6 ? "transparent" : "");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("data", data_r4)("hasParent", true);
} }
function EntityComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "div", 4);
} }
function EntityComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "div", 4);
} }
const _c0 = ".org-chart-entity-border[_ngcontent-%COMP%]{border-left:1px solid green;border-top:1px solid green}.org-chart-entity-connector[_ngcontent-%COMP%]{height:2em}.org-chart-entity-box[_ngcontent-%COMP%]{padding:.25em .5em;display:flex;flex-direction:column;align-items:center;border:1px solid #0085ca;background-color:#0085ca;border-radius:3px;cursor:pointer;box-shadow:0 .5rem 1rem #777!important}.org-chart-entity-name[_ngcontent-%COMP%]{white-space:nowrap;color:#fff;text-transform:capitalize}.org-chart-entity-type[_ngcontent-%COMP%]{white-space:nowrap;color:#fff;font-size:10px;text-transform:capitalize}.org-chart-container[_ngcontent-%COMP%]{display:flex;flex:1}.org-chart-sub-container[_ngcontent-%COMP%]{display:flex;flex-direction:column}.org-chart-connector-container[_ngcontent-%COMP%]{display:flex}.org-chart-connector[_ngcontent-%COMP%]{flex:1}";
let OrgChartComponent = class OrgChartComponent {
    constructor() {
        this.hasParent = false;
        this.hideChild = false;
    }
    toggleShowChild(value) {
        this.hideChild = !this.hideChild;
    }
};
OrgChartComponent.ɵfac = function OrgChartComponent_Factory(t) { return new (t || OrgChartComponent)(); };
OrgChartComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: OrgChartComponent, selectors: [["angular-org-chart"]], inputs: { hasParent: "hasParent", data: "data" }, decls: 3, vars: 4, consts: [[3, "data", "hasParent", "hideChild", "toggleChild", 4, "ngIf"], [1, "org-chart-container"], [4, "ngFor", "ngForOf"], [3, "data", "hasParent", "hideChild", "toggleChild"], [1, "org-chart-sub-container"], [1, "org-chart-connector-container"], [1, "org-chart-connector", "org-chart-entity-border"], [1, "org-chart-entity-border"], [3, "data", "hasParent"]], template: function OrgChartComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, OrgChartComponent_org_chart_entity_0_Template, 1, 3, "org-chart-entity", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵtemplate(2, OrgChartComponent_ng_container_2_Template, 7, 6, "ng-container", 2);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.data);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵstyleProp("display", ctx.hideChild ? "none" : "flex");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.data == null ? null : ctx.data.children);
    } }, directives: function () { return [ɵngcc1.NgIf, ɵngcc1.NgForOf, EntityComponent, OrgChartComponent]; }, styles: ["[_nghost-%COMP%]{display:flex;flex-direction:column;align-items:center;flex-wrap:wrap;padding-bottom:5px}", _c0] });
__decorate([
    Input(),
    __metadata("design:type", Object)
], OrgChartComponent.prototype, "data", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], OrgChartComponent.prototype, "hasParent", void 0);

let EntityComponent = class EntityComponent {
    constructor() {
        this.toggleChild = new EventEmitter();
        this.hasParent = false;
    }
    toggleShowChild() {
        this.toggleChild.emit(new Date());
    }
};
EntityComponent.ɵfac = function EntityComponent_Factory(t) { return new (t || EntityComponent)(); };
EntityComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: EntityComponent, selectors: [["org-chart-entity"]], inputs: { hasParent: "hasParent", data: "data", hideChild: "hideChild" }, outputs: { toggleChild: "toggleChild" }, decls: 7, vars: 4, consts: [["class", "org-chart-entity-connector org-chart-entity-border", 4, "ngIf"], [1, "org-chart-entity-box", 3, "click"], [1, "org-chart-entity-name"], [1, "org-chart-entity-type"], [1, "org-chart-entity-connector", "org-chart-entity-border"]], template: function EntityComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, EntityComponent_div_0_Template, 1, 0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵlistener("click", function EntityComponent_Template_div_click_1_listener() { return ctx.toggleShowChild(); });
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵtext(3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "div", 3);
        ɵngcc0.ɵɵtext(5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(6, EntityComponent_div_6_Template, 1, 0, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.hasParent);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate(ctx.data == null ? null : ctx.data.name);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate(ctx.data == null ? null : ctx.data.type);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", (ctx.data == null ? null : ctx.data.children.length) && !ctx.hideChild);
    } }, directives: [ɵngcc1.NgIf], styles: ["[_nghost-%COMP%]{margin:0 1em;display:flex;flex-direction:column;align-items:center}", _c0] });
__decorate([
    Output(),
    __metadata("design:type", Object)
], EntityComponent.prototype, "toggleChild", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], EntityComponent.prototype, "data", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], EntityComponent.prototype, "hasParent", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], EntityComponent.prototype, "hideChild", void 0);

let OrgChartModule = class OrgChartModule {
};
OrgChartModule.ɵfac = function OrgChartModule_Factory(t) { return new (t || OrgChartModule)(); };
OrgChartModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: OrgChartModule });
OrgChartModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(OrgChartComponent, [{
        type: Component,
        args: [{
                selector: 'angular-org-chart',
                template: "<org-chart-entity *ngIf=\"data\" [data]=\"data\" [hasParent]=\"hasParent\" (toggleChild)=\"toggleShowChild($event)\" [hideChild]=\"hideChild\"></org-chart-entity>\n<div class=\"org-chart-container\" [style.display]=\"hideChild ? 'none' : 'flex'\">\n\t<ng-container *ngFor=\"let data of data?.children; first as isFirst; last as isLast\">\n\t\t<div class=\"org-chart-sub-container\">\n\t\t\t<div class=\"org-chart-connector-container\">\n\t\t\t\t<div class=\"org-chart-connector org-chart-entity-border\" [style.border-color]=\"isFirst?'transparent':''\"></div>\n\t\t\t\t<div class=\"org-chart-entity-border\"></div>\n\t\t\t\t<div class=\"org-chart-connector org-chart-entity-border\" [style.border-color]=\"isLast?'transparent':''\"></div>\n\t\t\t</div>\n\t\t\t<angular-org-chart [data]=\"data\" [hasParent]=\"true\"></angular-org-chart>\n\t\t</div>\n\t</ng-container>\n</div>",
                styles: [":host{display:flex;flex-direction:column;align-items:center;flex-wrap:wrap;padding-bottom:5px}", ".org-chart-entity-border{border-left:1px solid green;border-top:1px solid green}.org-chart-entity-connector{height:2em}.org-chart-entity-box{padding:.25em .5em;display:flex;flex-direction:column;align-items:center;border:1px solid #0085ca;background-color:#0085ca;border-radius:3px;cursor:pointer;box-shadow:0 .5rem 1rem #777!important}.org-chart-entity-name{white-space:nowrap;color:#fff;text-transform:capitalize}.org-chart-entity-type{white-space:nowrap;color:#fff;font-size:10px;text-transform:capitalize}.org-chart-container{display:flex;flex:1}.org-chart-sub-container{display:flex;flex-direction:column}.org-chart-connector-container{display:flex}.org-chart-connector{flex:1}"]
            }]
    }], function () { return []; }, { hasParent: [{
            type: Input
        }], data: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(EntityComponent, [{
        type: Component,
        args: [{
                selector: 'org-chart-entity',
                template: "<div class=\"org-chart-entity-connector org-chart-entity-border\" *ngIf=\"hasParent\"></div>\n<div class=\"org-chart-entity-box\" (click)=\"toggleShowChild()\">\n\t<div class=\"org-chart-entity-name\">{{data?.name}}</div>\n\t<div class=\"org-chart-entity-type\">{{data?.type}}</div>\n</div>\n<div class=\"org-chart-entity-connector org-chart-entity-border\" *ngIf=\"data?.children.length && !hideChild\"></div>\n",
                styles: [":host{margin:0 1em;display:flex;flex-direction:column;align-items:center}", ".org-chart-entity-border{border-left:1px solid green;border-top:1px solid green}.org-chart-entity-connector{height:2em}.org-chart-entity-box{padding:.25em .5em;display:flex;flex-direction:column;align-items:center;border:1px solid #0085ca;background-color:#0085ca;border-radius:3px;cursor:pointer;box-shadow:0 .5rem 1rem #777!important}.org-chart-entity-name{white-space:nowrap;color:#fff;text-transform:capitalize}.org-chart-entity-type{white-space:nowrap;color:#fff;font-size:10px;text-transform:capitalize}.org-chart-container{display:flex;flex:1}.org-chart-sub-container{display:flex;flex-direction:column}.org-chart-connector-container{display:flex}.org-chart-connector{flex:1}"]
            }]
    }], function () { return []; }, { toggleChild: [{
            type: Output
        }], hasParent: [{
            type: Input
        }], data: [{
            type: Input
        }], hideChild: [{
            type: Input
        }] }); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(OrgChartModule, { declarations: function () { return [OrgChartComponent, EntityComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [OrgChartComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(OrgChartModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule
                ],
                declarations: [OrgChartComponent, EntityComponent],
                exports: [
                    OrgChartComponent
                ]
            }]
    }], null, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { OrgChartModule, OrgChartComponent as ɵa, EntityComponent as ɵb };

//# sourceMappingURL=angular-org-chart.js.map